// use this component only on mobile editor, dont use on desktop browser version
import { useEffect } from 'react';
import EditorControls from '../../Editor/EditorControls';

function ModalEditContent({slides, selectedSlide, selectedSlideIndex, setActionUpdateTemplate, reRender, showModalCrop}) {
    useEffect(()=>{
        document.addEventListener('focusin', (e) => {
            if (e.target.closest(".tox-tinymce, .tox-tinymce-aux, .moxman-window, .tam-assetmanager-root") !== null) {
                e.stopImmediatePropagation();
            }
        });
    });
    return (
        <div className={`tbcourse-modal tbcourse-modal-new-slide modal-mobile-builder modal`} id="tbcourse-modal-edit-slide-content" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <h5 className="modal-title font-size-20">Edit Content</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body font-family-inter pt-0">
                    <EditorControls slides={slides} selectedSlide={selectedSlide} selectedSlideIndex={selectedSlideIndex} structures={selectedSlide?.template?.structures() ?? {}} reRender={reRender} showModalCrop={showModalCrop} />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary font-weight-bold rounded-6 font-size-12 px-4 py-2" data-bs-dismiss="modal">Save</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalEditContent;